// auto-generated by Typewriter template _models.tst from PortCall.Models\Billing\QuickBooks\QuickBooksJobTracking.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// QuickBooksJobTrackingData is the class that QuickBooksJobTracking serializes to/from
export interface QuickBooksJobTrackingData {
	
	
    Customer : string | null;
}

// QuickBooksJobTrackingOptions is the class which may be passed to the QuickBooksJobTracking constructor to define optional initial data values
export interface QuickBooksJobTrackingOptions {
	
	
    Customer? : string | null;
}

export class QuickBooksJobTracking {
	
	
    public Customer : DataSignal<string | null>;

    constructor();
    constructor(data : QuickBooksJobTrackingOptions);
    constructor(data: QuickBooksJobTrackingOptions | null = null) {
	    
	    
        this.Customer = jsonableObservable(S.value<string | null>(data && data.Customer !== undefined ? data.Customer : null));
    }

    static key(obj : QuickBooksJobTracking) {
        return ;
    }
    
    static dataKey(obj : QuickBooksJobTrackingOptions) {
        return ;
    }

    static update(obj : QuickBooksJobTracking, data : QuickBooksJobTrackingOptions) {
        S.freeze(() => {
	        
	        
            if (data.Customer !== undefined) obj.Customer(data.Customer);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/QuickBooksJobTracking.ts